import React from 'react'

class MeterageParaSettingDiv extends React.Component {
    state = {
        id: this.props.id || 0,
        instrumentID: this.props.instrumentID || 0,
        readOnly: this.props.readOnly || false,
    }

    componentDidMount = () => {
        this.doGetMeteragePara()
    }

    doGetMeteragePara = () => {
        const { id, instrumentID } = this.state
        Tyan.doPostEvent('GetMeteragePara', {
            data: { id, instrumentID },
            onEnd: ({ errorMessage, optionsParas, initValues基本信息 }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                } else {
                    this.setState({ optionsParas, initValues基本信息, changedValues基本信息: {} })
                }
            }
        })
    }

    handlerSave = () => {
        const { onClose, onRefresh } = this.props
        const { instrumentID } = this.state
        Tyan.doPostEvent('SaveMeteragePara', {
            data: { instrumentID, ...Tyan.utility.getChangedFieldsets(this, '基本信息', false) },
            onEnd: ({ errorMessage }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                } else {
                    Ext.toast('保存成功')
                    onClose && onClose()
                    onRefresh && onRefresh()
                }
            }
        })
    }

    handlerDelete = () => {
        const { onClose, onRefresh } = this.props
        const { id } = this.state
        Tyan.pubForm.showConfirm('确定要删除？', () =>
            Tyan.doPostEvent('DelMeteragePara', {
                data: { id },
                onEnd: ({ errorMessage }) => {
                    if (errorMessage) {
                        Tyan.pubForm.showError(errorMessage)
                    } else {
                        Ext.toast('删除成功')
                        onClose && onClose()
                        onRefresh && onRefresh()
                    }
                }
            })
        )
    }

    handlerClose = () => {
        const { onClose } = this.props
        if (!this.bChanged()) {
            onClose && onClose()
            return
        }
        Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
    }

    canSave = () => {
        return this.bChanged() && !Tyan.checkForm.checkLimited(this)
    }

    bChanged = () => {
        return Tyan.utility.hasChangedValues(this)
    }


    fieldset基本信息 = () => {
        return [
            { _text: '计量参数', required: true, },
            { _text: '技术要求', maxRows: 3, required: true, },
            { _int: '计量周期（月）', name: '计量周期', required: true, textAlign: 'left', },
            { _int: '期间核查周期（月）', name: '期间核查周期', textAlign: 'left', },
            { _text: '备注', maxRows: 3 },
        ]
    }

    render() {
        const { showMessage: Message, showBody: Body } = this.props
        const { id, readOnly, initValues基本信息 } = this.state
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />

        return <Body data={this} maxWidth={600}
            controls={
                readOnly ? [{ _button: '关闭', handler: this.handlerClose }] :
                    [
                        { _button: '保存', handler: this.handlerSave, disabled: !this.canSave() },
                        { _button: '删除', handler: this.handlerDelete, cdt: () => id > 0 },
                        { _button: this.bChanged() && '取消' || '关闭', handler: this.handlerClose },
                    ]}
            fieldsets={
                [
                    { title: '', name: '基本信息', _fieldset: this.fieldset基本信息(), disabled: readOnly },
                ]}
        />
    }
}

export default MeterageParaSettingDiv